import { type Enum } from '@webapp/infrastructure/types/Enum'

export const A2uiTableLayouts = {
  TABLE: 'table',
  CARDS: 'cards',
} as const

export type A2uiTableLayoutEnum = Enum<typeof A2uiTableLayouts>
